const MailIcon = ({ color }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="11.5477" cy="11.5477" r="11.5477" fill="white" />
      <rect
        x="3.42969"
        y="6"
        width="16.366"
        height="12.0017"
        rx="1.6366"
        fill="#002133"
      />
      <path
        d="M3.17969 6.63231L11.6081 14.5925L20.0366 6.16406"
        stroke="white"
        strokeWidth="1.32615"
        strokeLinejoin="round"
      />
      <path
        d="M9.01562 12.0008L3.18056 17.1875"
        stroke="white"
        strokeWidth="1.32615"
      />
      <path
        d="M14.2031 12.0008L20.0382 17.1875"
        stroke="white"
        strokeWidth="1.32615"
      />
    </svg>
  );
};

export default MailIcon;
